var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53033 2.46967C3.23744 2.17678 2.76256 2.17678 2.46967 2.46967C2.17678 2.76256 2.17678 3.23744 2.46967 3.53033L3.53033 2.46967ZM11 11.75C11.4142 11.75 11.75 11.4142 11.75 11L11.75 4.25C11.75 3.83579 11.4142 3.5 11 3.5C10.5858 3.5 10.25 3.83579 10.25 4.25V10.25H4.25C3.83579 10.25 3.5 10.5858 3.5 11C3.5 11.4142 3.83579 11.75 4.25 11.75L11 11.75ZM2.46967 3.53033L10.4697 11.5303L11.5303 10.4697L3.53033 2.46967L2.46967 3.53033Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L20.4697 21.5303ZM13 12.25C12.5858 12.25 12.25 12.5858 12.25 13L12.25 19.75C12.25 20.1642 12.5858 20.5 13 20.5C13.4142 20.5 13.75 20.1642 13.75 19.75V13.75H19.75C20.1642 13.75 20.5 13.4142 20.5 13C20.5 12.5858 20.1642 12.25 19.75 12.25L13 12.25ZM21.5303 20.4697L13.5303 12.4697L12.4697 13.5303L20.4697 21.5303L21.5303 20.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.09e47892baa4616fb6239806bc0b906c.svg";
export { ForwardRef as ReactComponent };